import { Button } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import searchPageLabels from "../../search/searchPageLabels.json";
const { buttons } = searchPageLabels;
const GlobalExportButton = ({ onExport }) => {
  return (
    <>
      <Button
        className="text-sm font-medium bg-[#183D5D] text-white rounded-full flex shadow-xl hover:bg-[#4A90E2]"
        icon={<ExportOutlined />}
        onClick={onExport}
      >
        {buttons.globalExport}
      </Button>
    </>
  );
};
export default GlobalExportButton;
